export const settings = {
  title: "DBARS",
  // default meta description, kept identical to the static one in public/index.html
  description:
    "DBARS è il club dei migliori bar italiani: scopri i locali, i loro menù e gli orari, e trova il posto giusto per il tuo prossimo aperitivo.",
  // canonical origin: no "www" — www.dbars.it redirects here with a 301,
  // so every canonical/sitemap URL must use this form
  siteUrl: "https://dbars.it",
  apiUrl: "https://api.dbars.it/api",
  ckdPath: "https://api.dbars.it/",
  config: {
    limit: 60,
    sortingField: "id",
    sortingOrder: "desc",
  },
  //googleApiKey: "AIzaSyDimZ_LfSQ3qFkmWOlbJzN0OVwx4NulMaI",
  googleApiKey: "AIzaSyB0JItfx2zvDnKkmxIBt_wru36tOVcx1iM", //maps
};
